export const getters = {
  user: (state: any) => state.user,
  token: (state: any) => state.token
}